export enum ActorID {
  /** apify/website-content-crawler */
  WEB_CRAWLER = 'aYG0l9s7dbB7j3gbS',
  /** clockworks/free-tiktok-scraper */
  TIKTOK = 'OtzYfK1ndEGdwWFKQ',
  /** apify/instagram-post-scraper */
  INSTAGRAM = 'nH2AHrwxeTRJoN5hX',
  /** junglee/free-amazon-product-scraper */
  AMAZON = 'XVDTQc4a7MDTqSTMJ',
  /** curious_coder/linkedin-post-search-scraper */
  LINKEDIN = 'kfiWbq3boy3dWKbiL',
  /** kaitoeasyapi/twitter-x-data-tweet-scraper-pay-per-result-cheapest */
  X = 'CJdippxWmn9uRfooo',
  /** canadesk/apple-app-store */
  APPLE_APP_STORE = 'CKzFHpBSaMwlc9OLU',
  /** canadesk/google-play-store */
  GOOGLE_PLAY_STORE = 'e1S1S6ChqqeuI4xJg',
  /** apify/facebook-posts-scraper */
  FACEBOOK = 'KoJrdxJCTtpon81KY',
  /** streamers/youtube-scraper */
  YOUTUBE = 'h7sDV53CddomktSi5',
}
